import { render, staticRenderFns } from "./AllPatientHistoryDialog.vue?vue&type=template&id=222f5995&scoped=true&lang=pug&"
import script from "./AllPatientHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./AllPatientHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./AllPatientHistoryDialog.vue?vue&type=style&index=0&id=222f5995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f5995",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VCard,VCardActions,VCardText,VCol,VDivider,VIcon,VImg,VRow,VSkeletonLoader})
